import { useEffect, useMemo, useRef, useState } from 'react';
import classNames from 'classnames';


function DragDropFileMulti({
    dragText,
    onChange,
    className,
    accept,
    uploadIcon,
    description,
}) {
    // const [fileList, setFileList] = useState()
    // drag state
    const [dragActive, setDragActive] = useState(false);
    // ref
    const inputRef = useRef(null);

    // handle drag events
    const handleDrag = function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === 'dragenter' || e.type === 'dragover') {
            setDragActive(true);
        } else if (e.type === 'dragleave') {
            setDragActive(false);
        }
    };

    // validate file
    const handleValidateFile = (file) => {
        const acceptList = accept.split(',').map((type) => type.trim().toLowerCase());
    
        const fileExt = '.' + file.name.split('.').pop().toLowerCase();
    
        return acceptList.includes(fileExt);
    };

    // triggers when file is dropped
    const handleDrop = function (e) {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);

        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            onChange(
                Array.from(e.dataTransfer.files).filter((file) =>
                    handleValidateFile(file)
                )
            );
        }
    };

    // triggers when file is selected with click
    const handleChange = function (e) {
        e.preventDefault();

        if (e.target.files && e.target.files.length > 0) {
            onChange(
                Array.from(e.target.files).filter((file) =>
                    handleValidateFile(file)
                )
            );
        }
    };

    return (
        <form
            className={classNames('form-file-upload', className)}
            onDragEnter={handleDrag}
            onSubmit={(e) => e.preventDefault()}
        >
            <input
                accept={accept}
                ref={inputRef}
                type="file"
                id="input-file-upload"
                multiple={true}
                onChange={handleChange}
            />

            <label
                id="label-file-upload"
                htmlFor="input-file-upload"
                className={dragActive ? 'drag-active' : ''}
            >
                {uploadIcon ? (
                    uploadIcon
                ) : (
                    <i className="fa-solid fa-cloud-arrow-up"></i>
                )}
                <p className="btn-drag-file">
                    {dragText || '動画アップロード又はドラッグ＆ドロップ'}
                </p>
                <p className="description">{description}</p>
            </label>
            {dragActive && (
                <div
                    id="drag-file-element"
                    onDragEnter={handleDrag}
                    onDragLeave={handleDrag}
                    onDragOver={handleDrag}
                    onDrop={handleDrop}
                ></div>
            )}
        </form>
    );
}

export default DragDropFileMulti;
